import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NotifierService } from 'angular-notifier';
import { NgxSpinnerService } from 'ngx-spinner';
import { ArService } from 'src/app/services/ar.service';
import * as moment from 'moment';
import { Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap';
import { YesNoConfirmation1Component } from '../modal-pop-ups/yes-no-confirmation1/yes-no-confirmation1.component';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-ar-unassigned',
  templateUrl: './ar-unassigned.component.html',
  styleUrls: ['./ar-unassigned.component.scss']
})
export class ArUnassignedComponent implements OnInit {
  filters_form: FormGroup;
  private notifier: NotifierService;
  isShow: boolean = false;
  searchText;
  stations;
  arUnaasingedTrans = [];
  activeTab;
  constructor(private spinner: NgxSpinnerService,
    notifier: NotifierService,
    private arService: ArService,
    private modalService: BsModalService,
    private router: Router) {
    this.notifier = notifier;

  }

  ngOnInit() {
    this.getDetailsByStations();
  }

  ManualClosure(id) {
    //console.log(id)
    const initialState = {
      title: `Do you want to manually close the payment for the Reservation ${id} ?`,
      currentTabIndex : 0
    };
    const modalRef = this.modalService.show(YesNoConfirmation1Component, { initialState });
    modalRef.setClass('modal-lg modal-dialog-centered modal-dialog-scrollable');
    modalRef.content.event.subscribe(res => {
     // console.log(res)
      if (res.data) {
       // console.log(res.data)
        let resIdsList = [];
        resIdsList.push(id);
        let postData = {
          "resIds": resIdsList
        }
        this.spinner.show();
        this.arService.ManualClosurePayment(postData).subscribe(resData => {
          this.getDetailsByStations();
          this.notifier.notify('success', 'Payment has been closed manually.');
          this.spinner.hide();
          setTimeout(() => {
            this.reload('home/ar-dashboard');
          }, 1000);
   
        }, (error: any) => {
          this.spinner.hide();
          console.log(error);
        });
      } else {
        modalRef.hide()
      }
    })
  }

  getDetailsByStations(payload = {}) {
    this.searchText = ''
    this.spinner.show();
    this.arService.getUnAssignedTransactions(payload).subscribe(res => {
      this.spinner.hide();
      if (res['status'] && res['result'].length > 0) {
        this.arUnaasingedTrans = res['result'];
      } else {
        this.arUnaasingedTrans = []
      }
    });
    if(Object.keys(payload).length === 0) this.isShow = false;
  }


  getTime(date) {
    return moment.utc(date).format('MMM DD, YYYY HH:mm')
  }

  async reload(url: string): Promise<boolean> {
    await this.router.navigateByUrl('.', { skipLocationChange: true });
    return this.router.navigateByUrl(url);
  }
  showFilter() {
    this.isShow = !this.isShow;
  }

  exportExcel() {
    const exportData = this.arUnaasingedTrans.map(trans => ({
      'Res ID': trans.RESID,
      'Res Type': trans.RES_TYPE,
      'Res Status': trans.RESSTATUS,
      'Billing Status': trans.GREET_SERVICE_BACKOFFICE_STATUS || '',
      'Currency': trans.CURRENCY_FLAG,
      'Station': trans.STATION,
      'Res Created Date': trans.RESCREATIONDT ? moment(trans.RESCREATIONDT).format('DD/MM/YYYY') : '',
      'Res Start Date': trans.STARTDT ? moment(trans.STARTDT).format('DD/MM/YYYY') : '',
      'Sub Total': trans.TRANSACTION_SUBTOTAL,
      'Tax': trans.TRANSACTION_TAXES,
      'Total Due': trans.TRANSACTION_TOTAL
    }));

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(exportData);
    const workbook: XLSX.WorkBook = {
      Sheets: { 'Report': worksheet },
      SheetNames: ['Report']
    };

    XLSX.writeFile(workbook, 'Payment_Type_Pending_Transactions.xlsx');
  }
}
